const APP_NATIVE_FORMAT_PATTERN = /^app_native(?:_(\d+))?$/;

export const parseAppNativeFormat = (adFormat) => {
    const normalizedFormat = typeof adFormat === 'string' ? adFormat.toLowerCase() : '';
    const match = normalizedFormat.match(APP_NATIVE_FORMAT_PATTERN);

    if (!match) {
        return null;
    }

    return {
        adFormat: 'app_native',
        exitButtonTimeDelay: match[1] === undefined ? 0 : Number(match[1]),
    };
};

export const encodeAppNativeFormat = (delay = 0) => {
    const normalizedDelay = Number(delay);
    return normalizedDelay === 0 ? 'app_native' : `app_native_${normalizedDelay}`;
};

export const normalizeAdFormatFamily = (adFormat) => {
    return parseAppNativeFormat(adFormat)?.adFormat || adFormat;
};

export const getAdFormatLabel = (adFormat) => {
    const appNativeFormat = parseAppNativeFormat(adFormat);
    if (appNativeFormat) {
        return appNativeFormat.exitButtonTimeDelay > 0
            ? `App Native (${appNativeFormat.exitButtonTimeDelay}s delay)`
            : 'App Native';
    }

    return typeof adFormat === 'string' ? adFormat.replace(/_/g, ' ') : '';
};
